var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-time"},[_c('div',{staticClass:"time R"},[_vm._v(_vm._s(_vm.dateTime.time))]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.dateTime.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }